import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  const loginUser = async (event) => {
    event.preventDefault();
    if (!email || !password) {
      alert('Invalid credentials');
      return;
    }

    const response = await fetch('/refund/online-student/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ emailId: email, password: password }),
    });

    const data = await response.json();

    if (data.message === 'this email id does not exist') {
      alert('Email id does not exist');
    } else if (data.message === 'please enter correct password') {
      alert('Please enter correct password');
    } else if (data.message === 'not eligible for refund') {
      setShowModal(true); // Show modal if user not eligible
    } else {
      // setShowModal(true); s
      navigate('/refund-request');
    }
  };

  return (
    <>
      {/* Main Login UI */}
      <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
        <div className="w-full max-w-md bg-white shadow-lg rounded-lg p-8 border-t-4 border-orange-600">
          <h2 className="text-2xl font-semibold text-center text-orange-600 mb-6">
            AICEE 2026 Refund Portal
          </h2>
          <form onSubmit={loginUser} className="space-y-5">
            {/* Email Field */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email"
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            {/* Password Field with Eye Toggle */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="w-full border border-gray-300 rounded px-4 py-2 pr-10 focus:outline-none focus:ring-2 focus:ring-orange-400"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span
                  className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-500"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>

            {/* Submit Button */}
            <div className="text-center">
              <button
                type="submit"
                className="w-full bg-orange-600 hover:bg-orange-700 text-white py-2 rounded-md font-semibold transition"
              >
                Login
              </button>
            </div>
          </form>
           <p className="font-semibold text-[14px] text-algin:'justify' mt-2" style={{ textAlign: 'justify' }}>
          <span className='text-red-600 text-base'>Note:</span> <span className="font-normal">Refund Portal is now Active for All Eligible students and students can claim their refund till 30th July,2026 11:00 PM.</span>
        </p>
        </div>
        
      </div>

      


      {/* Modal: Not Eligible */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-500 bg-opacity-60 backdrop-blur-sm">
          <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full text-center border-t-4 border-red-500">
            <h2 className="text-2xl font-semibold text-red-600 mb-3">
              Not Eligible for Refund
            </h2>
            <p className="text-gray-700">
              Sorry, you are not eligible for a refund (As per the AICEE refund policy).
            </p>
            <button
              onClick={() => setShowModal(false)}
              className="mt-6 bg-orange-600 hover:bg-orange-700 text-white px-6 py-2 rounded transition"
            >
              Close
            </button>
          </div>
        </div>
      )}

    </>
  );
};

export default LoginForm;
